import {
  Box,
  Card,
  CardContent,
  Grid2,
  IconButton,
  Slide,
  Typography,
} from "@mui/material";
import React from "react";
// import TeamAndKeyTableList from "./TeamAndKeyTableList";
// import Skills from "./skills";
// import SowQuestionaire from "./SowQuestionaire";
// import SowBidProcess from "./SowBidProcess";
// import KeyMilestoneTableList from "./KeyMilestoneTableList";
import AlertCircleIco from "../../../../assets/icons/AlertCircleIco";
import CheckIco from "../../../../assets/icons/CheckIco";
import { StyledFlexColumnView } from "../../../common-components/StyledComponents";
import Skills from "../../sow-enrichment-copy/components/skills";
import AssembleTeamTableList from "./AssembleTeamTableList";
import DesiredCompositionTableList from "./DesiredCompositionTableList";
import KeyDeliverables from "./KeyDeliverables";
import ProposalGanttChart from "./ProposalGanttChart";
import Questionnaire from "./Questionnaire";
import SowDocuments from "./SowDocuments";

// const initialSections = [
//   {
//     name: "Key Deliverables",
//     status: "Review Pending",
//     icon: <SquareBoxTickIco />,
//   },
//   {
//     name: "Team Composition",
//     status: "Review Pending",
//     icon: <TeamCompositionIco />,
//   },
//   {
//     name: "Assemble Team",
//     status: "Review Pending",
//     icon: <AssembleTeamIco />,
//   },
//   {
//     name: "Project Timeline",
//     status: "Review Pending",
//     icon: <ProjectTimelineIco />,
//   },
//   {
//     name: "Questionnaire",
//     status: "Review Pending",
//     icon: <QuestionnaireIco />,
//   },
//   { name: "Documents", status: "Review Pending", icon: <DoucmentIco /> },
// ];

const statusColors = {
  Verified: "#4CAF50", // Green
  "Review Pending": "#FFA500", // Orange
};

const Checklist = ({
  headerData,
  alignment,
  handleDeleteSkillRow,
  handleAddNewSkill,
  open,
  jobModifyData,
  handleSkillToogleChange,
  tableContainerRef,
  handleSkillTextChange,
  isLoading,
  isEdit,
  seeClicked,
  sections,
  handleClickVerify,
  selectedTab,
  handleCheckListCardClick,
  documentSelectedRows,
  documentTableData,
  handleDocumentFileChange,
  handleDocumentUploadClick,
  documentStatusOptions,
  handleDocumentStatusChange,
  handleDocumentTableBodyData,
  handleDocumentRowCheckboxChange,
  fileInputRef,
  openDialog,
  mileStonesTableData,
  formData,
  handleAddTeam,
  handleChangeText,
  handleChange,
  handleClickAddTeam,
  handleCloseDialog,
  handleSkillDropDown,
  handleRecLevelStatusChange,
  handleMileLoctionStatusChange,
  skillDropDownData,
  totalCost,
}) => {
  // const [openDialog, setOpenDialog] = useState(false);
  // const [selectedTab, setSelectedTab] = useState(0);
  // const [selectedTab, setSelectedTab] = useState(0);
  // const [sections, setSections] = useState(initialSections);
  // const [mileStonesTableData, setMileStonesTableData] = useState([
  //   {
  //     id: 100,
  //     team: "Salesforce Project Manager",
  //     cost: "$200",
  //     reqLevel: "Jesse Matthews - 92%",
  //     req: "1",
  //     recLevel: "Junior",
  //     rec: "0.75",
  //     location: "Onsite",
  //     allocation: "75%",
  //   },
  //   {
  //     id: 101,
  //     team: "Salesforce Business Analyst/Administrator",
  //     cost: "$2500",
  //     reqLevel: "NA",
  //     req: "1",
  //     recLevel: "Senior",
  //     rec: "0.2",
  //     location: "India",
  //     allocation: "20%",
  //   },
  //   {
  //     id: 102,
  //     team: "Salesforce Developer",
  //     cost: "$6000",
  //     reqLevel: "NA",
  //     req: "1",
  //     recLevel: "Mid-Level",
  //     rec: "1.5",
  //     location: "Hybrid",
  //     allocation: "100%",
  //   },
  //   {
  //     id: 103,
  //     team: "Salesforce Architect",
  //     cost: "$2000",
  //     reqLevel: "Sushir Singh - 96%",
  //     req: "1",
  //     recLevel: "Mid-Level",
  //     rec: "0.5",
  //     location: "India",
  //     allocation: "50%",
  //   },
  //   {
  //     id: 104,
  //     team: "Salesforce Quality Assurance Analyst",
  //     cost: "$150",
  //     reqLevel: "NA",
  //     req: "1",
  //     recLevel: "Mid-Level",
  //     rec: "1",
  //     location: "Romania",
  //     allocation: "60%",
  //   },
  //   {
  //     id: 105,
  //     team: "DevOps Personnel",
  //     cost: "$150",
  //     reqLevel: "NA",
  //     req: "1",
  //     recLevel: "Mid-Level",
  //     rec: "0.5",
  //     location: "India",
  //     allocation: "20%",
  //   },
  // ]);
  // const [formData, setFormData] = useState({
  //   designation: "",
  //   seniority: "",
  //   resourceCount: "",
  //   hrs: "",
  //   location: "",
  //   allocation: "",
  //   cost: "",
  // });

  // useEffect(() => {
  //   if (seeClicked) {
  //     setSelectedTab(5);
  //   }
  // }, [seeClicked]);

  // const totalCost = mileStonesTableData.reduce((sum, item) => {
  //   return sum + parseFloat(item.cost.replace("$", ""));
  // }, 0);

  // const handleAddTeam = () => {
  //   const newTeamMember = {
  //     id: (mileStonesTableData.length + 100).toString(),
  //     team: formData.designation,
  //     recLevel: formData.seniority,
  //     resources: formData.resourceCount,
  //     hrs: formData.hrs,
  //     reqLevel: "NA",
  //     location: formData?.location,
  //     allocation: `${formData?.allocation}%`,
  //     cost: `$${formData?.cost}`,
  //   };

  //   setMileStonesTableData((prevData) => [...prevData, newTeamMember]);
  //   handleCloseDialog();
  // };

  // const handleClickVerify = () => {
  //   setSections((prevSections) =>
  //     prevSections.map((section, index) =>
  //       index === selectedTab ? { ...section, status: "Verified" } : section
  //     )
  //   );
  // };

  // const handleClickSaveAsDraft = () => {
  //   setSections((prevSections) =>
  //     prevSections.map((section, index) =>
  //       index === selectedTab
  //         ? { ...section, status: "Review Pending" }
  //         : section
  //     )
  //   );
  // };

  // const handleChangeText = (field) => (event) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     [field]: event.target.value,
  //   }));
  // };

  // const handleChange = (field, value) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     [field]: value,
  //   }));
  // };

  // const handleClickAddTeam = () => {
  //   setOpenDialog(true);
  // };

  // const handleCloseDialog = () => {
  //   setOpenDialog(false);
  //   setFormData({
  //     designation: "",
  //     senority: "",
  //     resourceCount: "",
  //     hrs: "",
  //     location: "",
  //   });
  // };

  // const [skillDropDownData, setSkillDropDownData] = useState(
  //   mileStonesTableData[0]?.team
  // );

  // const handleSkillDropDown = (e, selectedOption) => {
  //   setSkillDropDownData(e.target.value);
  // };

  // const handleRecLevelStatusChange = (event, rowId) => {
  //   const newStatus = event.target.value;
  //   setMileStonesTableData((prevData) =>
  //     prevData.map((row) =>
  //       row.id === rowId ? { ...row, recLevel: newStatus } : row
  //     )
  //   );
  // };

  // const handleMileLoctionStatusChange = (event, rowId) => {
  //   const newStatus = event.target.value;
  //   setMileStonesTableData((prevData) =>
  //     prevData.map((row) =>
  //       row.id === rowId ? { ...row, location: newStatus } : row
  //     )
  //   );
  // };

  return (
    <Box p={2}>
      <Grid2 container spacing={2} justifyContent="center">
        {sections.map((section, index) => (
          <Grid2 item key={index} size={2}>
            <Card
              variant="outlined"
              sx={{
                textAlign: "center",
                cursor: "pointer",
                border:
                  selectedTab === index
                    ? "2px solid #A97FFF"
                    : "1px solid #E0E0E0",
                borderRadius: "12px",
                boxShadow:
                  selectedTab === index
                    ? "0px 4px 10px rgba(169, 127, 255, 0.2)"
                    : "none",
                display: "flex", // Ensures consistent height
                flexDirection: "column",
                height: "100%", // Ensures it takes full height
              }}
              // onClick={() => setSelectedTab(index)}
              onClick={() => handleCheckListCardClick(index)}
            >
              <CardContent>
                <IconButton
                  sx={{
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  {section?.icon}
                </IconButton>
                <Typography
                  sx={{ fontSize: "14px", fontWeight: 600, color: "#101828" }}
                >
                  {section.name}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    // color: statusColors[section.status],
                    marginTop: "10px",
                    fontSize: "12px",
                    fontWeight: 500,
                    color: "#475467",
                  }}
                >
                  {section.status === "Verified" ? (
                    <CheckIco />
                  ) : (
                    <AlertCircleIco />
                  )}
                  &nbsp;{section.status}
                </Typography>
              </CardContent>
            </Card>
          </Grid2>
        ))}
      </Grid2>

      <Box mt={4}>
        <Slide
          direction="right"
          in={selectedTab === 0}
          timeout={500}
          mountOnEnter
          unmountOnExit
        >
          <div>
            <KeyDeliverables handleClickVerify={handleClickVerify} />
          </div>
        </Slide>
        <Slide
          direction="right"
          in={selectedTab === 1}
          timeout={500}
          mountOnEnter
          unmountOnExit
        >
          <StyledFlexColumnView>
            <DesiredCompositionTableList
              handleClickVerify={handleClickVerify}
              mileStonesTableData={mileStonesTableData}
              totalCost={totalCost}
              handleAddTeam={handleAddTeam}
              handleCloseDialog={handleCloseDialog}
              handleClickAddTeam={handleClickAddTeam}
              formData={formData}
              handleChange={handleChange}
              handleChangeText={handleChangeText}
              openDialog={openDialog}
              handleRecLevelStatusChange={handleRecLevelStatusChange}
              handleMileLoctionStatusChange={handleMileLoctionStatusChange}
            />
            <Skills
              headerData={headerData}
              alignment={isEdit ? alignment : ""}
              handleDeleteSkillRow={handleDeleteSkillRow}
              handleAddNewSkill={handleAddNewSkill}
              open={open}
              jobModifyData={jobModifyData}
              handleSkillToogleChange={handleSkillToogleChange}
              tableContainerRef={tableContainerRef}
              handleSkillTextChange={handleSkillTextChange}
              isLoading={isLoading}
              isShownHeaderTitle
              isMargin
              isToggle={false}
              skillDropDownData={skillDropDownData}
              skillDropDown={[
                ...mileStonesTableData.map((item) => ({
                  name: item.team, // Extract team names
                  id: item.id,
                })),
              ]}
              handleSkillDropDown={handleSkillDropDown}
            />
          </StyledFlexColumnView>
        </Slide>
        <Slide
          direction="right"
          in={selectedTab === 2}
          timeout={500}
          mountOnEnter
          unmountOnExit
        >
          <div>
            <AssembleTeamTableList handleClickVerify={handleClickVerify} />
          </div>
        </Slide>

        <Slide
          direction="right"
          in={selectedTab === 3}
          timeout={500}
          mountOnEnter
          unmountOnExit
        >
          <div>
            <ProposalGanttChart isEdit handleClickVerify={handleClickVerify} />
          </div>
        </Slide>

        <Slide
          direction="right"
          in={selectedTab === 4}
          timeout={500}
          mountOnEnter
          unmountOnExit
        >
          <div>
            <Questionnaire isEdit handleClickVerify={handleClickVerify} />
          </div>
        </Slide>

        <Slide
          direction="right"
          in={selectedTab === 5}
          timeout={500}
          mountOnEnter
          unmountOnExit
        >
          <div>
            <SowDocuments
              handleClickVerify={handleClickVerify}
              seeClicked={seeClicked}
              documentSelectedRows={documentSelectedRows}
              documentTableData={documentTableData}
              handleDocumentFileChange={handleDocumentFileChange}
              handleDocumentUploadClick={handleDocumentUploadClick}
              documentStatusOptions={documentStatusOptions}
              handleDocumentStatusChange={handleDocumentStatusChange}
              handleDocumentTableBodyData={handleDocumentTableBodyData}
              handleDocumentRowCheckboxChange={handleDocumentRowCheckboxChange}
              fileInputRef={fileInputRef}
            />
          </div>
        </Slide>
      </Box>

      <Grid2
        container
        spacing={2}
        sx={{ display: "flex", justifyContent: "center" }}
        mt={"24px"}
      >
        {/* <Grid2 item>
          <CommonButton
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="700"
            value="Mark as verified"
            padding="8px 15px"
            onClick={handleClickVerify}
          />

        </Grid2> */}
        {/* <Grid2 item size={{ xs: 12 }}>
          <CommonTextField
            border={"0.5px solid #EAECF0"}
            padding={15}
            placeholder={"Ask Haley anything"}
            bgColor={"#F7F8F9"}
            startIcon={
              <InputAdornment position="start">
                <img src={Haley} />
              </InputAdornment>
            }
            endComponent={
              <CommonButton
                // onClick={() => setAi(!ai)}
                fontWeight={600}
                padding={"8px 25px"}
                value={"Ask Haley"}
                endIcon={<AutoAwesome />}
              />
            }
          />
        </Grid2> */}
      </Grid2>
    </Box>
  );
};

export default Checklist;
